import { VideoProject } from "@/services/bedrock";

export function editorSubmitEvent(
  requiresQa?: boolean | null
): VideoProject.Event.SUBMIT_FOR_QA_REVIEW | VideoProject.Event.COMPLETE {
  return requiresQa ? VideoProject.Event.SUBMIT_FOR_QA_REVIEW : VideoProject.Event.COMPLETE;
}
